export default {"src":"/_next/static/media/fiveKg_64.917781f0.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};